<script>
import HollowDotsSpinner from '@/components/common/HollowDotsSpinner.vue';
import Hint from '@/components/common/Hint';

export default {
  name: 'Card',
  components: {
    HollowDotsSpinner,
    Hint,
  },
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
    maskLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    padded: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <div class="ui-card" :class="{ 'ui-card--padded': padded }">
    <header v-if="title || $slots.title" class="ui-card__title">
      <slot name="title">
        <div class="ui-card__default-title">
          <h5>
            {{ title }}
            <Hint v-if="hint" :message="hint" />
          </h5>

          <div>
            <slot name="actions" />
          </div>
        </div>
      </slot>
    </header>

    <div v-if="loading" class="ui-card__content ui-card__loading">
      <HollowDotsSpinner
        :animation-duration="900"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
        filled
      />
    </div>

    <div v-else class="ui-card__content">
      <slot />

      <HollowDotsSpinner
        v-if="maskLoading"
        :animation-duration="900"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
        is-masked
        filled
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
$container-radius: 12px;
$border-color: #f2f2f2;
$card-padding: 1.5rem;

.ui-card {
  box-shadow: none;
  border-radius: $container-radius;
  border: 1px solid $border-color;
  background-color: #fff;
  padding: 0 !important;
  margin: 0;

  /* stylelint-disable-next-line */
  & + & {
    margin-top: 1.5rem !important;
  }

  &__title {
    font-size: 0.9rem;
    line-height: 1.6rem;
    border-bottom: 1px solid $border-color;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
    }
  }

  &__default-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 0.5rem;
    padding: $card-padding;
  }

  &__loading {
    min-height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  &__content {
    position: relative;
  }

  &--padded &__content {
    padding: $card-padding;
  }

  .hollow-dots-spinner {
    border-radius: $container-radius;
  }
}
</style>
